"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoriteController = void 0;
const gs = require("@ivanlog/gs");
const AppControllerBase_1 = require("../../classes/appControllers/AppControllerBase");
const AppPM_1 = require("../AppPM");
class FavoriteController extends AppControllerBase_1.AppControllerBase {
    constructor(app) {
        super(app);
        this._favoritedIds = new Set();
        this._onFavoriteChangeToken = new gs.EventGSToken();
        this.onFavoriteChange = new gs.EventGS(this._onFavoriteChangeToken);
    }
    initialize() {
        const json = localStorage.getItem(FavoriteController.StorageName);
        if (!json) {
            AppPM_1.AppPM.GUI.setFavoriteCount(0);
            return;
        }
        const ids = JSON.parse(json);
        for (const id of ids)
            this._favoritedIds.add(id);
        AppPM_1.AppPM.GUI.setFavoriteCount(this._favoritedIds.size);
    }
    addFavorite(id) {
        if (this._favoritedIds.has(id))
            return;
        this._favoritedIds.add(id);
        this._updateDB();
        this._onFavoriteChangeToken.invoke(this._favoritedIds.size);
    }
    removeFavorite(id) {
        if (!this._favoritedIds.has(id))
            return;
        this._favoritedIds.delete(id);
        this._updateDB();
        this._onFavoriteChangeToken.invoke(this._favoritedIds.size);
    }
    isFavorite(id) {
        return this._favoritedIds.has(id);
    }
    getFavorites() {
        return [...this._favoritedIds];
    }
    _updateDB() {
        AppPM_1.AppPM.GUI.setFavoriteCount(this._favoritedIds.size);
        localStorage.setItem(FavoriteController.StorageName, JSON.stringify(this.getFavorites()));
    }
}
exports.FavoriteController = FavoriteController;
FavoriteController.StorageName = "favoriteProducts";
//# sourceMappingURL=FavoriteController.js.map